export default "__VITE_ASSET__BWJXghuT__"